const LOOPBACK_HOSTS = ['localhost', '127.0.0.1', '[::1]', '::1'];

export const THIS_COMPUTER = 'an app on this computer';

const isLoopback = (host: string) => {
  const value = host.toLowerCase();
  return (
    LOOPBACK_HOSTS.includes(value) ||
    LOOPBACK_HOSTS.includes(value.replace(/:\d+$/, ''))
  );
};

export const redirectHostLabel = (host: string) =>
  isLoopback(host) ? THIS_COMPUTER : host;
